<template>
  <basic-container>
    <avue-crud
        :option="option"
        :data="data"
        ref="crud"
        v-model="form"
        :page.sync="page"
        :permission="permissionList"
        @row-del="rowDel"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @search-change="searchChange"
        @search-reset="searchReset"
        @selection-change="selectionChange"
        @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            v-if="permission.param_delete"
            plain
            @click="handleDelete">删 除
        </el-button>
      </template>
      <template
          slot-scope="{row}"
          slot="roleId">
        <el-tag>{{ row.roleName }}</el-tag>
      </template>
      <template
          slot-scope="{row}"
          slot="deptId">
        <el-tag>{{ row.deptName }}</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, remove, update, add } from '@/api/sys/param'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      selectionList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        tip: false,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        column: [
          {
            label: '参数名称',
            prop: 'paramName',
            search: true,
            rules: [{
              required: true,
              message: '请输入参数名称'
            }]
          },
          {
            label: '参数键名',
            prop: 'paramKey',
            search: true,
            rules: [{
              required: true,
              message: '请输入参数键名'
            }]
          },
          {
            label: '参数键值',
            prop: 'paramValue',
            rules: [{
              required: true,
              message: '请输入参数键值'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.vaildData(this.permission.sys_param_add, false),
        viewBtn: this.vaildData(this.permission.sys_param_view, false),
        delBtn: this.vaildData(this.permission.sys_param_delete, false),
        editBtn: this.vaildData(this.permission.sys_param_edit, false)
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  methods: {
    rowSave (row, done) {
      add(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowUpdate (row, index, done) {
      update(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }, () => {
        done()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove(row.id).then(() => {
          this.onLoad(this.page)
        })
      })
    },
    handleDelete () {
      const _this = this
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return remove(this.ids).then(() => {
          _this.onLoad(this.page)
          _this.$refs.crud.toggleSelection()
        })
      })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params) {
      this.onLoad(this.page, params)
    },
    selectionChange (list) {
      this.selectionList = list
    },
    onLoad (page, params = {}) {
      getList(page.currentPage, page.pageSize, params).then(res => {
        const data = res.data
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>

<style>
</style>
